import _regeneratorRuntime from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import _asyncToGenerator from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// 倒计时结束逻辑
import { useStore } from 'vuex';
import { useCommonSubmitEffect } from '@/effects/submitEffect';
export var useCommonCountDownEffect = function useCommonCountDownEffect() {
  var store = useStore();
  var _useCommonSubmitEffec = useCommonSubmitEffect(),
    handleSubmitClick = _useCommonSubmitEffec.handleSubmitClick;
  var handleCountDown = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(answers, submitFlag) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(store.getters.getQuesSetting.submitType === 1)) {
              _context.next = 7;
              break;
            }
            _Dialog({
              title: '提示',
              message: '时间到，试卷已自动提交'
            });
            _context.next = 4;
            return handleSubmitClick(answers);
          case 4:
            if (submitFlag) {
              submitFlag.value = false;
            }
            _context.next = 8;
            break;
          case 7:
            _Dialog({
              message: '已超时'
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCountDown(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    handleCountDown: handleCountDown
  };
};